import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-6 text-center">
          <div className="text-4xl mb-4">😔</div>
          <h2 className="text-lg font-semibold text-green-dark mb-2">
            Что-то пошло не так
          </h2>
          <p className="text-sm text-green-dark/60 mb-4">
            Попробуйте обновить страницу
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-green-primary text-white rounded-lg text-sm"
          >
            Обновить
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
